import { IGraph } from "../types";

export function compose(many: IGraph[], cfg): IGraph {
	if (many.length < 2) return many[0] || null;

	const ab = many[0].getBox();
	let dx = cfg.padding;

	const out = many.reduce((acc, v) => {
		const bb = v.getBox();

		v.translate({ x: ab[0][1] - bb[0][0] + dx, y: ab[1][0] - bb[1][0] });
		acc.importNodes(v.getNodes());

		dx += cfg.padding + bb[0][1] - bb[0][0];
		return acc;
	});

	if (many.length) out.setGlobalBox();

	return out;
}
